import React from 'react';

const LinkedIn = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width={props.width || 30}
        height={props.height || 30}
        aria-hidden="true"
        className={props.className}
    >
        <path
            d="M14.943 29.906c-4.226 0-8.452-.02-12.688.01-1.123.009-2.076-.774-2.227-1.84-.019-.114-.019-.227-.019-.33V2.178C.01.953.925.02 2.16.01 3.51 0 4.868.01 6.217.01c7.16 0 14.32.01 21.481-.009 1.16 0 1.944.783 2.132 1.519.057.207.095.424.095.632v25.585c0 1.207-.925 2.15-2.133 2.16-1.594.01-3.188 0-4.792 0-2.68.01-5.368.01-8.057.01zm1.02-16.859c0-.519-.01-1.047 0-1.566.009-.236-.086-.302-.312-.302-1.226.01-2.443 0-3.67 0-.368 0-.368 0-.368.368 0 4.547 0 9.085-.01 13.632 0 .293.095.368.369.359 1.264-.01 2.519 0 3.783-.01.368 0 .368 0 .368-.368 0-2.283-.01-4.575.01-6.858 0-.472.027-.953.112-1.415.17-.953.604-1.736 1.632-1.99.321-.086.66-.105.99-.095 1.067.01 1.727.51 1.963 1.547.132.566.18 1.16.189 1.745.019 2.35.01 4.708.01 7.057 0 .387.009.387.396.387 1.254 0 2.5-.01 3.754.01.274 0 .368-.076.368-.36-.01-2.726.019-5.452-.019-8.17a13.808 13.808 0 00-.34-2.707c-.367-1.585-1.292-2.745-2.914-3.198-.557-.16-1.151-.198-1.736-.264-1.029-.123-2 .104-2.896.623-.67.386-1.217.934-1.68 1.575zm-11.576 5.32c0 2.275 0 4.558-.01 6.831 0 .274.085.35.35.35 1.273-.01 2.556-.01 3.83 0 .245 0 .34-.067.34-.331-.01-4.575-.01-9.142 0-13.717 0-.264-.095-.33-.34-.32-1.274.009-2.538 0-3.812.009-.377 0-.377 0-.377.386.019 2.265.019 4.529.019 6.793zM6.65 9.265A2.579 2.579 0 009.245 6.68a2.585 2.585 0 00-2.603-2.604c-1.444 0-2.595 1.16-2.595 2.623a2.583 2.583 0 002.604 2.566z"
            fill="currentColor"
        />
    </svg>
);

export default LinkedIn;



// WEBPACK FOOTER //
// ./src/base/icons/LinkedIn.jsx